import { useEffect, useState } from "react";
import { notify } from "./Toast/Toast";

export default function ProfilePage(props) {
  const [success, setSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: localStorage.getItem("Name") || "",
    email: localStorage.getItem("email") || "",
  });

  const basePass = {
    oldPass: "",
    newPass: "",
    newPass2: "",
  };

  const [passwordField, setPasswordField] = useState(basePass);
  const [errorMessage, setErrorMessage] = useState("");
  const [passwordView, setPasswordView] = useState(false);

  // Handle changes to form inputs for name and email
  const handleFormChange = (e) => {
    setErrorMessage("");
    setSuccess(false);
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle changes to password inputs
  const handlePasswordChange = (e) => {
    setErrorMessage("");
    setSuccess(false);
    const { name, value } = e.target;
    setPasswordField((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Save new password
  const savePassword = () => {
    if (passwordField.newPass !== passwordField.newPass2) {
      setErrorMessage("Lösenord matchar inte");
      notify("error", "Lösenord matchar inte");
      return;
    }

    fetch("https://inventy.redata.se/inventdb/api_updatePassword.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        oldPassword: passwordField.oldPass,
        newPassword: passwordField.newPass,
        token: localStorage.getItem("token"),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setPasswordView(false);
          setPasswordField(basePass);
          notify("success", "Lösenordet sparades");
        } else {
          notify("error", data.message);
        }
      })
      .catch((error) => {
        console.error("Error accessing server: ", error);
        notify("error", "Kunde inte nå servern, försök igen senare");
      });
  };

  // Save user info (name and email)
  const saveInfo = () => {
    fetch("https://inventy.redata.se/inventdb/api_updateUserInfo.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        token: localStorage.getItem("token"),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          notify("success", "Uppgifter sparade");
          localStorage.setItem("Name", formData.name);
          localStorage.setItem("email", formData.email);
        } else {
          notify("error", data.message);
        }
      })
      .catch((error) => {
        console.error("Error accessing server: ", error);
        notify("error", "Kunde inte nå servern, försök igen senare");
      });
  };

  return passwordView ? (
    <>
      <div className="ProfileRow">
        <h3>Gammalt lösenord</h3>
        <input
          value={passwordField.oldPass}
          type="password"
          name="oldPass"
          onChange={handlePasswordChange}
        />
      </div>
      <div className="ProfileRow">
        <h3>Nytt lösenord</h3>
        <input
          value={passwordField.newPass}
          type="password"
          name="newPass"
          onChange={handlePasswordChange}
        />
      </div>
      <div className="ProfileRow">
        <h3>Upprepa lösenord</h3>
        <input
          value={passwordField.newPass2}
          type="password"
          name="newPass2"
          onChange={handlePasswordChange}
        />
      </div>
      <div
        className="ProfileRow"
        style={{ display: "flex", justifyContent: "space-evenly" }}
      >
        <button
          onClick={() => {
            setPasswordView(false);
          }}
        >
          Tillbaka
        </button>
        <button onClick={savePassword}>
          <h3>Spara</h3>
        </button>
      </div>
      <p style={{ color: "red" }}>{errorMessage}</p>
    </>
  ) : (
    <>
      <h1 style={{ marginBottom: "50px" }}>Mina uppgifter</h1>
      <div className="ProfileRow">
        <h3>Namn</h3>
        <input value={formData.name} name="name" onChange={handleFormChange} />
      </div>
      <div className="ProfileRow">
        <h3>Epost</h3>
        <input value={formData.email} name="email" onChange={handleFormChange} />
      </div>
      <div
        className="ProfileRow"
        style={{ display: "flex", justifyContent: "space-evenly" }}
      >
        <button
          onClick={() => {
            setPasswordView(true);
          }}
        >
          Byt Lösenord
        </button>
        <button onClick={saveInfo}>
          <h3>Spara</h3>
        </button>
      </div>
      <p style={{ color: "red" }}>{errorMessage}</p>
    </>
  );
}
